export abstract class ILibLocalStorage {
    abstract getApiToken(): string
    abstract setApiToken(token:any): void
    abstract clearApiToken(): void
}
